import * as React from 'react';
import { connect } from 'react-redux';
import { PORTABLE_POSSESSIONS_RISK } from '../../../routes/routes';
import './PortablePossessions.css';
import { postToController } from '../../../actions/apiActions';
import { navigateTo } from '../../../actions/navigationActions';
import { addPortablePossessionsToQuote, setPortablePossessionsLastClaim, getBlingQuotes } from '../../../actions/salesActions';
import { ProgressBar, Button, Dropdown, Image, Form } from 'react-bootstrap';
import { PRODUCT_BLING } from '../../../constants/constants';

class PortablePossessionsClaimHistory extends React.PureComponent<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            nextDisabled: true,
            claimHistoryList: [],
            selectedClaimHistory: '',
            selectedClaimHistoryDropdown: false,
            loggedIn: this.props.auth.uid ? true : false,
        };
        this.handleRedirect = this.handleRedirect.bind(this);
        this.handleBack = this.handleBack.bind(this);
        this.handleClaimHistorySelection = this.handleClaimHistorySelection.bind(this);
        this.handleClaimHistoryDropdownToggle = this.handleClaimHistoryDropdownToggle.bind(this);
        this.handleClick = this.handleClick.bind(this);
    }

    async handleClick() {
        this.props.dispatchSetPortablePossessionsClaimHistory(this.state.selectedClaimHistory);
        this.props.dispatchAddPortablePossessionsToQuote(this.props.sales.quoteType == PRODUCT_BLING);
    }

    handleRedirect(nextPage: string) {
        this.props.redirectTo(nextPage);
    }

    async componentDidMount() {
        await this.getClaimHistory()
    }

    async getClaimHistory() {
        await postToController(this.props.dispatch, 'GetClaimHistory', JSON.stringify({})).then(async (response) => {
            if (this.props.sales.portablePossessionRisk.id >= 1)
                await this.setState({ claimHistoryList: response.filter(x => x.id <= 1) });
            else {
                await this.setState({ claimHistoryList: response.filter(x => x.id > 1) });
            }
            return true;
        })
    }

    async handleClaimHistorySelection(e: any) {
        /* eslint eqeqeq: "off" */
        let claimHistory = this.state.claimHistoryList.filter(function (item) {
            return item.id == e
        })
        /* eslint eqeqeq: "warn" */
        await this.setState({ selectedClaimHistory: claimHistory[0] });
        this.setState({ nextDisabled: claimHistory[0] === undefined });
    }

    async handleClaimHistoryDropdownToggle(e: any) {
        await this.setState({
            selectedClaimHistoryDropdown: !this.state.selectedClaimHistoryDropdown
        });
    }

    async handleBack(e: any) {
        this.props.redirectTo(PORTABLE_POSSESSIONS_RISK)
    }

    public render() {
        let claimHistoryDrop = [];
        if (this.state.claimHistoryList.length > 0) {
            claimHistoryDrop = this.state.claimHistoryList.map((item) => {
                return <Dropdown.Item eventKey={item.id} key={item.id}>{item.description}</Dropdown.Item>
            });
        }
        return (
            <div className={this.state.loggedIn ? "pt-lg-5 p-lg-0 logged-in" : "pt-lg-5 p-lg-05 logged-out"}>
                <div className="col-12 text-lg-center text-md-center">
                    <div className="container portal-possession-claim">
                        <div className="row justify-content-center mobile-mt-60px">
                            <div className="col-lg-12 col-md-12">
                                <div className="row justify-content-center">
                                    <div className="col-2 col-md-3 col-lg-3 col-xl-2 pt-lg-2 text-center align-self-center">
                                        <div className="BackRectangle d-none d-lg-block d-md-block">
                                            <button onClick={this.handleBack} className="Back cursor-pointer"><img src="./images/OnlineQuotation/icon-back-button-desktop.png" alt="" /></button>
                                        </div>
                                        <div className="sidenav d-lg-none d-md-none" id="mySidenav">
                                            <button onClick={this.handleBack} className="Back cursor-pointer" id="about"><img src="./images/OnlineQuotation/icons-navigation-quote-back-btn.png" alt="" /></button>
                                        </div>
                                    </div>
                                    <div className="col-10 col-md-9 col-lg-9 col-xl-10 p-0 text-center align-self-center">
                                        <div>
                                            <ProgressBar variant="success" now={35} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="container mt-32px mobile-mt-20px portable-claim-margin">
                        <div className="row justify-content-center">
                            <div className="col-lg-12 col-md-12 nopa">
                                <div className="row noma">
                                    <div className="col nopa"></div>
                                    <div className="col-lg-10 nopa">
                                        <div className="ssp-addportable-possessions-crown-icon mt-0px text-center">
                                            <div className="ssp-sales-journey-crown-icon" title="Add portable possessions"></div>
                                        </div>
                                        <div className="ssp-portable-possession-claims-main-contentholder mt-21px mobile-mt-17px mb-28px mobile-mb-30px text-center ssp-addreplacement-value-p-holder">
                                            <div className="font-size-16px font-weight-normal ssp-addreplacement-value-intro-header">
                                                {this.props.sales.quoteType === PRODUCT_BLING && "Alrighty, now please let us know how many months/years ago you (the policyholder) submitted a cellphone claim"}
                                                {this.props.sales.quoteType !== PRODUCT_BLING && "Alrighty, please tell us how many months/years ago you (the policyholder) submitted a claim"}
                                            </div>
                                        </div>
                                        <div className="row noma">
                                            <div className="col-lg-12 col-md-12 col-12 nopa mb-40px">
                                                <Form.Label className={'left-align nopa mb-6px temp-text-box-label' + (this.state.selectedClaimHistory !== "" ? "" : " no-opacity d-none")}>Select no. of months/years </Form.Label>
                                                <Dropdown
                                                    id="claimHistory-select-dropdown"
                                                    className="fit-full mb-0px"
                                                    drop='down'
                                                    onSelect={this.handleClaimHistorySelection}
                                                    onToggle={this.handleClaimHistoryDropdownToggle}>
                                                    <Dropdown.Toggle id="dropdown-basic">
                                                        <div className="row dropdown-height">
                                                            <div className="dropdown-basic-title-text col-11 mr-15px mobile-mr-0px">
                                                                {this.state.selectedClaimHistory.description}
                                                                {!this.state.selectedClaimHistory &&
                                                                    <p>Select no. of months/years</p>
                                                                }
                                                            </div>
                                                            <Image src='Images/red-arrow-up-24-px.svg' className={this.state.selectedClaimHistoryDropdown ? 'visible' : 'invisible'} alt="" />
                                                            <Image src='Images/red-arrow-down-24-px.svg' className={this.state.selectedClaimHistoryDropdown ? 'invisible' : 'visible'} alt="" />
                                                        </div>
                                                    </Dropdown.Toggle>
                                                    <Dropdown.Menu id='claimHistoryDropDown'>
                                                        {claimHistoryDrop}
                                                    </Dropdown.Menu>
                                                </Dropdown>
                                            </div>
                                        </div>
                                        <div className="row noma justify-content-center mt-40px">
                                            <div className="col-12 col-lg-4 nopa">
                                                <Button className="btn btn-block btn-solid-red" id="NextButton" disabled={this.state.nextDisabled} onClick={this.handleClick}>Next</Button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        profile: state.profile,
        sales: state.sales,
        auth: state.firebase.auth,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        redirectTo: (des) => dispatch(navigateTo(des)),
        dispatchAddPortablePossessionsToQuote: (flag) => dispatch(addPortablePossessionsToQuote(flag)),
        dispatchAddBlingToQuote: () => dispatch(getBlingQuotes()),
        dispatchSetPortablePossessionsClaimHistory: (selectedPortablePossessionsClaimHistory: any) => dispatch(setPortablePossessionsLastClaim(selectedPortablePossessionsClaimHistory))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(PortablePossessionsClaimHistory);